import base64 from 'base-64'
import '@okta/okta-auth-js/polyfill';
import { OktaAuth } from '@okta/okta-auth-js'
import oktaConfigs from './okta-config'
import i18nConfig from './i18nConfig';
const orgUrl = window.location.href.indexOf("mycargill") > -1 ? process.env.CUSTOM_ORG_URL : process.env.ORG_URL;
let config = oktaConfigs.getConfig()

const baseUrl = window.location.protocol + "//" + window.location.hostname +
(window.location.port ? ':' + window.location.port : ''); // process.env.BASE_URL;

let environment = process.env.NODE_ENV;
let brandDetails = "";
console.log('env=====', environment);
if (environment === 'production') {
  brandDetails = require('../brand-details.json');
} else if (environment === 'stage') {
  brandDetails = require('../brand-details-stage.json');
} else {
  brandDetails = require('../brand-details-dev.json');
}
var brand = brandDetails.data.filter(i => i.applicationUrls.indexOf(document.location.host) > -1)
// Load the Sign-In Widget module
// var OktaSignIn = require('@okta/okta-signin-widget');
const OktaSignIn = require('@okta/okta-signin-widget/dist/js/okta-sign-in.min.js');
var browserLang = 'en'
if (navigator.userLanguage !== undefined) {
  browserLang = navigator.browserLanguage
  console.log("browserLang: if " + browserLang)
} else {
  browserLang = navigator.language
  console.log("browserLang: else " + browserLang)
}
console.log(environment)
console.log(brand)
var urlLang = oktaConfigs.getParameterByName('lang', document.location.href)
let authparams = {
  issuer: config.issuer,
  responseType: config.responseType,
  scopes: config.scopes,
  display: 'page',
  pkce: config.pkce
}
let isRdEncode = oktaConfigs.getParameterByName('encode', document.location.href)
browserLang = urlLang ? urlLang.toLowerCase() : browserLang
console.log("After urlLang: " + browserLang)

var rd = oktaConfigs.getParameterByName('rd', document.location.href)
if (rd === undefined || rd === null || rd.trim() === '') {
  rd = oktaConfigs.getParameterByName('ReturnUrl', document.location.href)
} else {
  isRdEncode = true;
}
var isSamlRD = false
if (rd !== undefined && rd !== null && rd.trim() !== '') {
  if (isRdEncode === 'true') {
    rd = base64.decode(rd)
  }
  isSamlRD = true
  console.log('rd: ' + rd)
}
browserLang = browserLang.replace("_", "-")
browserLang = oktaConfigs.getBrowserLanguage(browserLang)
console.log("browser language final:" + browserLang)
var logoUrl = brand.length ? brand[0].loginwidgetlogo : 'static/1200px-Cargill_logo.svg.png'
const host = config.host
var otp = oktaConfigs.getParameterByName('otp', window.location.href)
var state = oktaConfigs.getParameterByName('state', window.location.href)
var isIdentifier = true;
var url = document.location.href.toLowerCase().split('/')[2]
if(url.indexOf('cargill') === -1 && url.indexOf('localhost') === -1) {
  isIdentifier = false;
}
var isClassicEngine = false;
const mmClient = process.env.MM_CLIENT_ID;
const clientId = config.clientId
if (url.indexOf('agresource') > -1 || clientId === mmClient) {
  isClassicEngine = true;
}
const authClient = new OktaAuth({
  baseUrl: orgUrl,
  issuer: config.issuer,
  language: browserLang,
  clientId: config.clientId,
  redirectUri: isSamlRD ? rd : config.redirectUrl,
  logo: logoUrl,
  authParams: authparams,
  useClassicEngine: isClassicEngine
});

// Use OktaSignIn
const oktaSignInClient = new OktaSignIn({
  el: '#widget-div',
  baseUrl: orgUrl,
  language: browserLang,
  useClassicEngine: isClassicEngine,
  clientId: config.clientId,
  redirectUri: isSamlRD ? rd : config.redirectUrl,
  logo: logoUrl,
  authParams: authparams,
  helpLinks: {
    help: baseUrl + '/Help'
  },
  features: {
    smsRecovery: true,
    rememberMe: (document.location.host.toLowerCase().indexOf('cargill') !== -1),
    selfServiceUnlock: true,
    showIdentifier: isIdentifier
  },
  i18n: i18nConfig,
  state,
  otp,
  transformUsername: function (username, operation) {
    // This example will append the '@acme.com' domain if the user has
    // not entered it
    // if (operation !== 'FORGOT_PASSWORD') {
    var url = document.location.href.toLowerCase().split('/')[2]
    if (url.indexOf('cargill') === -1 && url.indexOf('localhost') === -1 && !brand[0].noTranform) { // uncomment this block to enable login username transform | grainbridge should not transform -noTranform property = true in brand-details.json
      var brandcode = brand[0].brandCode
      return ('0' + (username.indexOf('@') + 1)).slice(-2) + brandcode + username.split('@').join('') + '@partneridentity.okta-emea.com'
    } else {
      return username.toLowerCase();
    }
  }
});

import storage from '@/helpers/storage'
export default {
  oktaSignIn() {
    var fromLogin = oktaConfigs.getParameterByName('fromLogin', window.location.href)
    if (isSamlRD) {
      oktaSignInClient.showSignInAndRedirect({
        // Assumes there is an empty element on the page with an id of 'osw-container'
        el: '#widget-div'
      })
    } else if (window.location.href.indexOf('action=unlock') > -1 || (host && base64.decode(host) === config.mmclient)) { // No need to check session for Milk Moovement application
      oktaSignInClient.showSignInAndRedirect({
        // Assumes there is an empty element on the page with an id of 'osw-container'
        el: '#widget-div'
      })
    } else if (fromLogin) {
      oktaSignInClient.authClient.signInWithRedirect()
    } else {
      oktaSignInClient.authClient.session.exists().then(function (exists) {
        if (exists) {
          oktaSignInClient.authClient.signInWithRedirect()
        } else {
          authClient.tokenManager.getTokens().then(({accessToken, idToken}) => {
            if (accessToken && idToken) {
              oktaSignInClient.authClient.token.getWithRedirect({
                el: '#widget-div',
                responseType: 'code'
              })
            } else {
              oktaSignInClient.showSignInAndRedirect()
            }
          })
        }
      })
    }
  },
  oktaWidgetRendered(handler) {
    oktaSignInClient.on('ready', function(res) {
      console.log(res);
      handler();
    })
  },
  checkTokens() {
    return new Promise((resolve, reject) => {
      authClient.tokenManager.getTokens().then(({accessToken, idToken}) => {
        if (accessToken && idToken) {
          storage.set('access_token', accessToken.accessToken)
          storage.set('id_token', idToken.idToken)
          resolve(accessToken, idToken)
        } else {
          resolve(false, false)
        }
      })
    })
  },
  oktaIsSessionActive() {
    return new Promise((resolve, reject) => {
      resolve(true)
      // oktaSignInClient.session.get(function (res) {
      //   // Session exists, show logged in state.
      //   if (res.status === 'ACTIVE') {
      //     storage.set('cf-user', {"sub": res.userId})
      //     resolve(true)
      //   } else {
      //     resolve(false)
      //   }
      // })
    })
  },
  getAccessToken() {
    return new Promise((resolve, reject) => {
      if (oktaSignInClient.tokenManager.get('access_token')) {
        resolve(oktaSignInClient.tokenManager.get('access_token'))
      } else {
        resolve(false)
      }
    })
  },
  addToTokenManager(key, val) {
    oktaSignInClient.tokenManager.add(key, val);
  },
  oktaSignOut(es) {
    if (es === 'access_denied') {
      es = '?' + es
    } else {
      es = ''
    }
    oktaSignInClient.authClient.signOut({
      postLogoutRedirectUri: `${window.location.origin}/Login${es}`
    });
  },
  oktaClearSession() {
    oktaSignInClient.session.get(function (res) {
      // Session exists, show logged in state.
      if (res.status === 'ACTIVE') {
        oktaSignInClient.session.close(function (err) {
          if (err) {
            // The user has not been logged out, perform some error handling here.
            console.error("Okta sign out error: ", err)
            return;
          }
        })
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/helpers/okta.js